import {
  type IGlobalTab,
  TabGroupName,
  TabType,
} from '@carboncopyco/types/desktop';

export const isTabTypeDemo = (tabType: TabType) =>
  [
    TabType.PRESENT_DEMO,
    TabType.GROUP_DEMO_PRESENTATION,
    TabType.GROUP_DEMO_PREVIEW,
  ].includes(tabType);

const isBrowserTab = (globalTab?: IGlobalTab) =>
  globalTab?.type === TabType.BROWSER_WINDOW ||
  globalTab?.type === TabType.DEMO_MOBILE_PRESENTATION ||
  globalTab?.type === TabType.GROUP_DEMO_MOBILE_PRESENTATION ||
  globalTab?.type === TabType.GROUP_DEMO_MOBILE_PREVIEW ||
  globalTab?.type === TabType.DEMO_MOBILE_PREVIEW;

const isPresentDeeplinkTab = (globalTab: IGlobalTab) =>
  [
    TabType.PRESENTER_DEEPLINK_DEMO,
    TabType.PRESENTER_DEEPLINK_PLAYBOOK,
  ].includes(globalTab.type);

const isHomeTabType = (globalTab?: IGlobalTab) =>
  globalTab?.type === TabType.BASIC;

export const isTabOpenFromEditor = (globalTab?: IGlobalTab) =>
  globalTab?.payload?.isOpenedFromEditor === true;

export const isTabTypePreviewDemo = (tabType: TabType) =>
  [TabType.PREVIEW_DEMO, TabType.PREVIEW_OVERLAY].includes(tabType);

const supportsMouseAnimation = (tab: IGlobalTab) =>
  Boolean(
    (tab.group?.name &&
      [
        TabGroupName.PlaybookPresentation,
        TabGroupName.PlaybookPreview,
        TabGroupName.DemoPresent,
      ].includes(tab.group.name)) ||
      (tab.group?.name === TabGroupName.DemoPreview &&
        !tab.payload?.isOpenedFromEditor)
  );

const supportsTextExtraction = (tab: IGlobalTab) =>
  [TabType.PREVIEW_CLONE, TabType.UPDATE_CLONE, TabType.CLONE].includes(
    tab.type
  );

export const isInfoPagePresentation = (tab: IGlobalTab) =>
  tab?.payload?.openFromInfoPage && tab?.payload?.forClient;

const isArchivedDemoOrPresentation = (tab: IGlobalTab) => {
  if (isTabTypePreviewDemo(tab.type)) {
    return tab.payload?.demo?.isDeleted;
  }
  if (isBrowserTab(tab) && !isInfoPagePresentation(tab)) {
    return tab?.payload?.play?.isDeleted || tab.payload?.demo?.isDeleted;
  }
  return tab?.payload?.presentation?.isDeleted;
};

export const isToursTab = (globalTab: IGlobalTab) => {
  return [TabType.TOURS_CREATE, TabType.LIVE_TOURS_CREATE].includes(
    globalTab.type
  );
};
export const shouldUseDefaultDebuggerInterceptor = (globalTab: IGlobalTab) =>
  [TabType.CLONE, TabType.UPDATE_CLONE].includes(globalTab.type);
// we can't use the enum from @demostack/types because it doesn't work in electron,
// and we need to use it in both main and renderer process,
// so we have to use 'live_demo' instead of RecordingTypes.overlay
export const isOverlayTab = (globalTab: IGlobalTab) =>
  [
    TabType.OVERLAY_EDITOR,
    TabType.PREVIEW_OVERLAY,
    TabType.LIVE_TOURS_CREATE,
  ].includes(globalTab.type) ||
  ((globalTab.type === TabType.PRESENT_DEMO ||
    globalTab.type === TabType.GROUP_DEMO_PRESENTATION ||
    globalTab.type === TabType.GROUP_DEMO_PREVIEW ||
    globalTab.type === TabType.PREVIEW_DEMO ||
    globalTab.type === TabType.TOURS_CREATE) && // TODO: consult with NN to fix this properly
    globalTab?.payload?.demo?.recordingType === 'live_demo');

export {
  isBrowserTab,
  isPresentDeeplinkTab,
  isHomeTabType,
  supportsMouseAnimation,
  isArchivedDemoOrPresentation,
  supportsTextExtraction,
};
